import styled from '@emotion/styled';

export const MoreInfo = styled('div')(
  () => `
  margin-bottom: 24px;
  font-family: Inter;
  max-width: 300px;

  .title {
    font-size: 13px;
    color: #888F99;
    margin-bottom: 4px;
  }

  .content {
    font-size: 16px;
    line-height: 20px;
    color: #000000;
  }
`,
);
